import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import CartIcon from "@/assets/icons/shopping-bag.svg?react";
import { ROUTES } from "@/utils/navigation";
import { emptyCartWrapperStyles } from "./styles";

interface IProps {
  closePopUp?: () => void;
}

const EmptyCart: React.FC<IProps> = ({ closePopUp }) => {
  return (
    <>
      <Box sx={emptyCartWrapperStyles}>
        <CartIcon />
      </Box>
      <Typography variant="h6" component="p" mb={1} textAlign="center">
        Your cart is empty
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        mb={6}
        textAlign="center"
      >
        Selected items will appear here
      </Typography>
      <Button
        component={Link}
        to={`${ROUTES.solutions}`}
        onClick={closePopUp}
        variant="contained"
        fullWidth
      >
        Shop
      </Button>
    </>
  );
};

export default EmptyCart;
